"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable getter-return */
// Used as a placeholder during reset database to catch illegal
// adapter calls
var throwError = function (name) {
  throw new Error("Cannot call database.adapter.".concat(name, " while the database is being reset"));
};

var ErrorAdapter =
/*#__PURE__*/
function () {
  function ErrorAdapter() {
    var _this = this;

    ['find', 'query', 'count', 'batch', 'getDeletedRecords', 'destroyDeletedRecords', 'unsafeResetDatabase', 'getLocal', 'setLocal', 'removeLocal', 'unsafeSqlQuery', 'testClone'].forEach(function (name) {
      // $FlowFixMe
      _this[name] = function () {
        return throwError(name);
      };
    });
  }

  _createClass(ErrorAdapter, [{
    key: "underlyingAdapter",
    get: function get() {
      throwError('underlyingAdapter');
    }
  }, {
    key: "schema",
    get: function get() {
      throwError('schema');
    }
  }, {
    key: "migrations",
    get: function get() {
      throwError('migrations');
    }
  }]);

  return ErrorAdapter;
}();

exports.default = ErrorAdapter;